import { create } from 'zustand';

interface StartupDriveState {
  shouldLaunchDrive: boolean;
  setShouldLaunchDrive: (value: boolean) => void;
}

export const useStartupDriveStore = create<StartupDriveState>((set) => ({
  shouldLaunchDrive: false,
  setShouldLaunchDrive: (value) => set({ shouldLaunchDrive: value }),
}));